import React from 'react';
import { useSelector } from 'react-redux';
import * as call from '../../../../call';
import SwitchPin from '../../SwitchPin';
const SwitchPinControl = () => {
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    if (!currentParticipant) {
        return null;
    }
    return <SwitchPin participantId={currentParticipant.id}/>;
};
export const SwitchPinControlKey = 'switch-pin-control';
export default SwitchPinControl;
